// extracted by mini-css-extract-plugin
export default {"container":"DevolutiveCard_container__EtTQz","showShadows":"DevolutiveCard_showShadows__6Kccy","likeAnimation":"DevolutiveCard_likeAnimation__OmUlr"};